export default __webpack_public_path__ + "static/media/realpics3.e831f5bb.jpg";